import { cva } from 'class-variance-authority';

export const BORDERED_BUTTON_GROUP_VARIANTS = cva(
  'outline outline-1 rounded-xs overflow-hidden min-h-10 flex [&>*:not(:last-child)]:border-r w-fit',
  {
    variants: {
      buttonColor: {
        primary:
          'outline-primary-base [&_button]:border-primary-base [&_[data-selected=true]]:bg-primary-base [&_[data-selected=false]]:text-primary-base',
        violet:
          'outline-violet-base [&_button]:border-violet-base [&_[data-selected=true]]:bg-violet-base [&_[data-selected=false]]:text-violet-base',
      },
    },
    defaultVariants: {
      buttonColor: 'primary',
    },
  },
);
